import { useMutation } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * COI-572 — restore portal access for revoked third-party contacts.
 *
 * This mutation has no GraphQL twin, so it uses TanStack Query directly rather
 * than the flag-gated mutation factory. The contacts page already loads revoked
 * rows and is route-gated for third-party updates; the server also enforces the
 * update permission before any identity-provider work begins.
 */
export const useRestoreThirdPartyContactAccess = () => {
  const trpc = useTRPC();

  return useMutation(
    trpc.frontend.thirdPartyContact.restoreAccess.mutationOptions()
  );
};
